import React, { useContext, useRef, useState } from "react";
import ReactModal from "react-modal";
import { PageContext } from "../../Context/PageContext";
import closeIcon from "../../Assets/closeIcon.svg";
import copylink from "../../Assets/copylink.svg";
import copymaillink from "../../Assets/copymail.svg";
import copyembedlink from "../../Assets/copyembedlink.svg";
import copylinkqrcode from "../../Assets/copylinkqr-code.svg";
import { Mail } from "@mui/icons-material";
import "../../Styles/Sharemodal.css";
import prvateFormicon from "../../Assets/prvateFormicon.svg";
import publicFormicon from "../../Assets/publicFormicon.svg";
import companyIcon from "../../Assets/companyIcon.svg";
import activeprvateFormicon from "../../Assets/activeprvateFormicon.svg";
import activepublicFormicon from "../../Assets/activepublicFormicon.svg";
import activecompanyIcon from "../../Assets/activecompanyIcon.svg";
import activecopylink from "../../Assets/activecopylink.svg";
import activecopymaillink from "../../Assets/activecopymaillink.svg";
import activecopyembedlink from "../../Assets/activecopyembedlink.svg";
import activecopylinkqrcode from "../../Assets/activecopylinkqrcode.svg";
import zIndex from "@mui/material/styles/zIndex";
ReactModal.setAppElement("#root"); // Ensure this matches your root element

const ShearModel = () => {
  const { showShearModel, link, setShowShearModel } = useContext(PageContext);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      borderRadius: "15px",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "50%",
      height: "auto",
      minHeight: "10rem",
      maxHeight: "90vh",
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      gap: "1rem",
    },
    overlay: {
      background: "rgba(0,0,0,0.25)",
      zIndex: '999'
    },
  };

  const [openlink, setOpenLink] = useState(true);
  const [openEmbed, setOpenEmbed] = useState(false);
  const [openMail, setOpenMail] = useState(false);
  const [openQrcode, setOpenQrcode] = useState(false);

  const linkRef = useRef();
  const handleCopyLink = async () => {
    if (linkRef.current) {
      const textToCopy = linkRef.current.innerText;
      try {
        await navigator.clipboard.writeText(textToCopy);
      } catch (err) {
        console.error("Failed to copy text:", err);
      }
    }
  };

  return (
    <>
      <ReactModal
        isOpen={showShearModel}
        onRequestClose={() => setShowShearModel(false)}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <>
          <div className="main-design">
            <div className="top_cotainer-share-model">
              <p style={{ fontFamily: "EuclidMedium", fontSize: '18px' }}>Send and receive responses</p>
              <img
                src={closeIcon}
                alt="closebtn"
                style={{ cursor: "pointer" }}
                onClick={() => setShowShearModel(false)}
              />
            </div>
            <div className="sheareOption_container">
              <div
                className="type_copylink"
                onClick={() => {
                  setOpenLink(true);
                  setOpenEmbed(false);
                  setOpenMail(false);
                  setOpenQrcode(false);
                }}
                style={{ fontFamily: openlink && "EuclidSemiBold" }}
              >
                <img src={openlink ? activecopylink : copylink} alt="" />
                <div className={`${openlink && "formTypeActive"}`}>
                  Copy link
                </div>
              </div>
              <div
                className="type_copylink"
                onClick={() => {
                  setOpenLink(false);
                  setOpenEmbed(false);
                  setOpenMail(true);
                  setOpenQrcode(false);
                }}
                style={{ fontFamily: openMail && "EuclidSemiBold" }}
              >
                <img
                  src={openMail ? activecopymaillink : copymaillink}
                  alt="copymaillink"
                />
                <div>Email</div>
              </div>
              <div
                className="type_copylink"
                onClick={() => {
                  setOpenLink(false);
                  setOpenEmbed(true);
                  setOpenMail(false);
                  setOpenQrcode(false);
                }}
                style={{ fontFamily: openEmbed && "EuclidSemiBold" }}
              >
                <img
                  src={openEmbed ? activecopyembedlink : copyembedlink}
                  alt="copyembedlink"
                />
                <div>Embed</div>
              </div>
              <div
                className="type_copylink"
                onClick={() => {
                  setOpenLink(false);
                  setOpenEmbed(false);
                  setOpenMail(false);
                  setOpenQrcode(true);
                }}
                style={{ fontFamily: openQrcode && "EuclidSemiBold" }}
              >
                <img
                  src={openQrcode ? activecopylinkqrcode : copylinkqrcode}
                  alt=""
                />
                <div>QR Code</div>
              </div>
            </div>
          </div>

          {openlink && <Link link={link} linkRef={linkRef} />}
          {openMail && <Email />}
          {openEmbed && <Embed />}
          {openQrcode && <QRCode />}
        </>
      </ReactModal>
    </>
  );
};

const Link = ({ link, linkRef }) => {
  const [prvateForm, setPrvateForm] = useState(true);
  const [publicForm, setPublicForm] = useState(false);
  const [companyForm, setCompanyForm] = useState(false);
  return (
    <div className="sharelinktype-container">
      <div className="shareline-container">
        <p style={{ fontFamily: 'EuclidMedium' }}>Share with link</p>
        <div className="input_for_linkShear" ref={linkRef}>
          {link}
        </div>
      </div>
      <div className="access-setting-type">
        <p className="accessSettings">Access Settings</p>

        <div className="accessType-container">
          <div
            className={`accresstype-card ${prvateForm && "formTypeActive"}`}
            onClick={() => {
              setPrvateForm(true);
              setPublicForm(false);
              setCompanyForm(false);
            }}
          >
            <div>
              <img
                src={prvateForm ? activeprvateFormicon : prvateFormicon}
                alt="prvateFormicon"
              />
            </div>
            <p className="accresstype-title">PRVATE FORM</p>
            <p className="accresstype-des">Only available to invited people</p>
          </div>
          <div
            className={`accresstype-card ${publicForm && "formTypeActive"}`}
            onClick={() => {
              setPrvateForm(false);
              setPublicForm(true);
              setCompanyForm(false);
            }}
          >
            <div>
              <img
                src={publicForm ? activepublicFormicon : publicFormicon}
                alt="publicFormicon"
              />
            </div>
            <p className="accresstype-title">PUBLIC FORM</p>
            <p className="accresstype-des">Available to every individual</p>
          </div>
          <div
            className={`accresstype-card ${companyForm && "formTypeActive"}`}
            onClick={() => {
              setPrvateForm(false);
              setPublicForm(false);
              setCompanyForm(true);
            }}
          >
            <div>
              <img
                src={companyForm ? activecompanyIcon : companyIcon}
                alt="companyIcon"
              />
            </div>
            <p className="accresstype-title">COMPANY ACCESS</p>
            <p className="accresstype-des">
              Only available to people in your organization
            </p>
          </div>
        </div>
      </div>
      <div className="link-container-share-container">
        <div className="permission-container">
          {prvateForm && (
            <>
              <p className="permission-title">Permission</p>
              <div className="permission-type-container">
                <div className="permission-type-text-container">
                  <p className="permission-type-title">Submit Only</p>
                  <p className="permission-type-des">
                    Invited people can view and submit the form only.
                  </p>
                </div>
                <input type="radio" name="permission" />
              </div>
              <div className="permission-type-container">
                <div className="permission-type-text-container">
                  <p className="permission-type-title">Submit & View Later</p>
                  <p className="permission-type-des">
                    Invited people can submit the form and view their
                    submissions later.
                  </p>
                </div>
                <input type="radio" name="permission" />
              </div>
              <div className="permission-type-container">
                <div className="permission-type-text-container">
                  <p className="permission-type-title">Submit & Edit Later</p>
                  <p className="permission-type-des">
                    Invited people can submit the form and view and edit their
                    submissions later.
                  </p>
                </div>
                <input type="radio" name="permission" />
              </div>
            </>
          )}
          {publicForm && (
            <>
              <p className="permission-title">Permission</p>
              <div className="permission-type-container">
                <div className="permission-type-text-container">
                  <p className="permission-type-title">Submit Only</p>
                  <p className="permission-type-des">
                    Invited people can view and submit the form only.
                  </p>
                </div>
                <input type="radio" name="permission" />
              </div>
              <div className="permission-type-container">
                <div className="permission-type-text-container">
                  <p className="permission-type-title">Submit & View Later</p>
                  <p className="permission-type-des">
                    Invited people can submit the form and view their
                    submissions later.
                  </p>
                </div>
                <input type="radio" name="permission" />
              </div>
              <div className="permission-type-container">
                <div className="permission-type-text-container">
                  <p className="permission-type-title">Submit & Edit Later</p>
                  <p className="permission-type-des">
                    Invited people can submit the form and view and edit their
                    submissions later.
                  </p>
                </div>
                <input type="radio" name="permission" />
              </div>
            </>
          )}
          {companyForm && (
            <>
              <p className="permission-title">Permission</p>
              <div className="permission-type-container">
                <div className="permission-type-text-container">
                  <p className="permission-type-title">Submit Only</p>
                  <p className="permission-type-des">
                    Invited people can view and submit the form only.
                  </p>
                </div>
                <input type="text" name="permission" />
              </div>
            </>
          )}
        </div>
      </div>
      <div className="shear_bt_container form-shear_bt_container ">
        <div
          className="cancel_button "
          // onClick={() => setShowShearModel(false)}
        >
          Cancel
        </div>
        <div className=" Copy_link share-btn">Copy Link</div>
      </div>
    </div>
  );
};

const Email = () => {
  return (
    <div className="email-container-share-container">
      <p className="email-share-text-lable">To</p>
      <div className="email-input-container">
        <input type="text" name="email" />
      </div>
      <p className="email-share-text-lable">Subject</p>
      <div className="email-input-container">
        <input type="text" name="subject" />
      </div>
      <p className="email-share-text-lable">
        Add an invitation message (optional)
      </p>
      <textarea className="" rows="5" />
    </div>
  );
};

const Embed = () => {
  return (
    <div className="embed-container-share-container">
      <p className="embed-title">Iframe</p>
      <p className="embed-text-des">
        Invited people can view and submit the form only.
      </p>
      <div></div>
    </div>
  );
};

const QRCode = () => {
  const iframe =
    "https://www.jotform.com/uploads/shimiyon21/form_files/250210957291050_1737614846_qrcode_muse.png";
  return (
    <div className="qrcode-container-share-container">
      <div>
        <p className="qrcode-title">To Embed The QR Code On Your Website,</p>
        <div className="Qr-code-container">
          <a href="https://form.jotform.com/shimiyon21/form" rel="no-follow">
            <img
              src="data:image/png;base64,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"
              width="100%"
              style={{ maxWidth: "200px" }}
              alt="QR Code for Jotform form"
            />
          </a>
          <p className="qrcode-text-des">
            Share this QR code with your audience to let them access the form
            directly on their devices.
          </p>
        </div>
      </div>
      <div>
        <p className="embed-title">Copy The Following HTML Code.</p>
        <div>
          <textarea
            className="embed-code-input"
            value={`<iframe src="${iframe}" width="100%" height="500" style="border:none;"></iframe>`}
            readOnly
            style={{ width: "100%", resize: "none" }}
          />
        </div>
      </div>
      <div className="Qrcode-btn-container">
        <button type="button" className="Qrcode-btn copy-btn">
          Copy Code
        </button>
        <button type="button" className="Qrcode-btn down-btn">
          Download QR
        </button>
      </div>
    </div>
  );
};
export default ShearModel;
